export default __webpack_public_path__ + "static/media/logo-salute.7048664f.png";